import React, { useEffect, useState } from "react";
import "./Categories.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Common_Heading_Round_holder from "../common-components/common_Heading_Round_holder/Common_Heading_Round_holder";
import Product_card from "../common-components/product_card/Product_card";
import Green_round_btn from "../common-components/common_btn/green_round_btn/Green_round_btn";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AllHealtConcern,
  getAllCategoriesWSub,
} from "../../features/master/masterSlice";

import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Container, Row, Col, Tab, Nav, Offcanvas } from "react-bootstrap";
import Category_Subcategory_Card from "../common-components/category_subcategory_card/Category_Subcategory_Card";
import { decodeId, variant_type } from "../../utils/common";
import GreenStrip from "../common-components/common_green_strip/GreenStrip";
import FilterComponent from "./filtercomponent/FilterComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faFilter } from "@fortawesome/free-solid-svg-icons";
import CategorySwiper from "../home/categories_swiper/CategorySwiper";
import All_Products from "./all_products/All_Products";
import {
  resetProductFilter,
  setProductFilter,
} from "../../features/products/productsSlice";

const STEP = 4;

function Categories() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const categoryId = queryParams.get("category_id");
  const concernId = queryParams.get("concern_id");
  const search = queryParams.get("search");

  useEffect(() => {
    const filterData = {};

    // Ids are normally encrypted; some links (footer, cards) pass plain numbers
    const resolveId = (value) => {
      if (/^\d+$/.test(value)) return Number(value);
      return Number(decodeId(value));
    };

    if (categoryId) {
      filterData.category_id = resolveId(categoryId);
    }

    if (concernId) {
      filterData.concerns = [resolveId(concernId)];
    }
    if (search) {
      filterData.name = search;
    }

    if (Object.keys(filterData).length) {
      // clear stale filters (subcategories, concerns, name...) from earlier visits
      dispatch(resetProductFilter());
      dispatch(setProductFilter(filterData));

      const params = new URLSearchParams(location.search);

      params.delete("category_id");
      params.delete("concern_id");
      params.delete("search");

      navigate(
        `${location.pathname}${
          params.toString() ? `?${params.toString()}` : ""
        }`,
        { replace: true },
      );
    }
  }, [categoryId, concernId]);

  const dispatch = useDispatch();

  const filters = useSelector((state) => state.product.filters);

  const [visibleCounts, setVisibleCounts] = useState([]);

  // reset filters when leaving the categories page
  useEffect(() => {
    return () => {
      dispatch(resetProductFilter());
    };
  }, [dispatch]);

  useEffect(() => {
    const scrollToId = location.state?.scrollToId;
    if (scrollToId) {
      const scroll = () => {
        const element = document.getElementById(scrollToId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          setTimeout(scroll, 100);
        }
      };
      scroll();
    }
  }, [location.state]);

  const categoriesWithSub = useSelector(
    (state) => state.master.categoriesWithSub,
  );
  const healt_concerns = useSelector((state) => state.master.healt_concerns);

  const catsBreakPoints = {
    320: { slidesPerView: 2 },
    450: { slidesPerView: 2.5 },
    575: { slidesPerView: 3 },
    768: { slidesPerView: 4 },
    992: { slidesPerView: 3.5 },
    1200: { slidesPerView: 4.5 },
    1400: { slidesPerView: 5 },
  };

  useEffect(() => {
    dispatch(getAllCategoriesWSub({}));
    dispatch(AllHealtConcern());
  }, [dispatch]);

  const [showFilter, setShowFilter] = useState(false);

  const handleCategoryCardClick = (id) => {
    dispatch(
      setProductFilter({
        category_id: Number(filters?.category_id) === Number(id) ? "" : id,
      }),
    );
  };

  return (
    <section className="Categories_section_holder Content-Section">
      <GreenStrip heading="Shop" />

      <div className="container">
        <div className="back_holder" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} className="back_icon" />
          <span>Back</span>
        </div>
        <div className="cats_content_holder">
          <div className="mobile_filter" onClick={() => setShowFilter(true)}>
            <FontAwesomeIcon icon={faFilter} className="filter" />
            <p className="in_text">Filter</p>
          </div>

          <div className="row">
            <div className="col-lg-3">
              <div className="desktop_filter">
                <FilterComponent
                  category={categoriesWithSub}
                  concerns={healt_concerns}
                />
              </div>
            </div>
            <div className="col-lg-9 ">
              <div className="cats_holder">
                <CategorySwiper
                  breakpoints={catsBreakPoints}
                  data={categoriesWithSub}
                  handleCategoryCardClick={handleCategoryCardClick}
                  show_acitve={true}
                  filters={filters}
                />
              </div>
              <div className="all_prods">
                <All_Products />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Offcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        placement="start"
        className="filter_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <div className="logo_holder">
            <img
              src="/assets/images/logo/redlottus-logo.png"
              className="offcanvaslogo_img"
              alt="logo"
            />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <FilterComponent
            category={categoriesWithSub}
            concerns={healt_concerns}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  );
}

export default Categories;
